import type {Components, Theme} from '@mui/material';
import {sliderClasses} from '@mui/material';

declare module '@mui/material/Slider' {
  export interface SliderPropsColorOverrides {
    success: true;
    error: true;
  }
}

export const MuiSlider = (theme: Theme): Components['MuiSlider'] => ({
  variants: [
    {
      props: {color: 'primary'},
      style: {
        color: theme.palette.text1,
        [`.${sliderClasses.valueLabel}`]: {
          background: theme.palette.negativeBg,
        },
      },
    },
    {
      props: {color: 'secondary'},
      style: {
        color: theme.palette.primaryBrandText,
        [`.${sliderClasses.valueLabel}`]: {
          background: theme.palette.primaryBrandBg,
        },
      },
    },
    {
      props: {color: 'success'},
      style: {
        color: theme.palette.approveText,
        [`.${sliderClasses.valueLabel}`]: {
          background: theme.palette.approveBg,
        },
      },
    },
    {
      props: {color: 'error'},
      style: {
        color: theme.palette.criticalText,
        [`.${sliderClasses.valueLabel}`]: {
          background: theme.palette.criticalBg,
        },
      },
    },
  ],
  styleOverrides: {
    root: {
      height: 4,
      display: 'block',
      width: 'calc(100% - 16px)',
      marginLeft: 'auto',
      marginRight: 'auto',
    },
    rail: {
      backgroundColor: theme.palette.bg3,
      opacity: 1,
    },
    thumb: {
      width: 16,
      height: 16,
      transform: 'translate(50%, -50%)',
    },
    mark: {
      color: theme.palette.text3,
    },
    markLabel: {
      transform: 'translateX(50%)',
      color: theme.palette.text3,
      fontSize: 10,
    },
    valueLabel: {
      borderRadius: +theme.shape.borderRadius * 1.5,
      boxShadow: theme.elevations.level3,
      padding: theme.spacing(0, 1),
    },
  },
});
